module.exports = "/_next/static/images/associationLogo5-7d3158b32fa0e725eaf77fa921b501f0.webp";